import { A4PowerGrid } from '@e3dc-react/icons'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import React from 'react'

interface Props {
  isVisible?: boolean
}

const GridStatusIcon: React.FC<Props> = ({ isVisible = false }) => {
  const tooltipText = 'installation-status.grid.tooltip'

  if (isVisible) {
    return (
      <OptionalTooltipWrapper titleKey={tooltipText}>
        <A4PowerGrid color="error" />
      </OptionalTooltipWrapper>
    )
  }

  return null
}

export default GridStatusIcon
